module.exports = __webpack_public_path__ + "img/DLsalessheet.svg";


//////////////////
// WEBPACK FOOTER
// ./img/DLsalessheet.svg
// module id = 250
// module chunks = 0